const getFormsByCharacteristic = (characteristic = []) => {
    const total = characteristic?.reduce((a, b) => a + b.n, 0);
    return total
  }
  
  export {getFormsByCharacteristic}